import { AutomationRulesLabel, creditTypeTexts } from "../components/shared/constants";
import { UtilityService } from "../services/UtilityService";
import { PhoneNumberModel } from "./phone-number.model";
import { CreditType } from "./plan-metrics.model";
import { UserModel } from "./users.model";


export interface ITransferFormModel {
    SourcePhoneID: string;
    TargetPhoneID: string;
    CreditType: CreditType;
    CreditsToTransfer: number;
}

export interface ITransferStatusModel {
    SourcePhoneNumber: string;
    SourcePhoneNumberName: string;
    TargetPhoneNumber: string;
    TargetPhoneNumberName: string;
    CreditTypeText: string;
    CreditsToTransfer: number;
}

export interface ITransferLogModel {
    SourcePhone: PhoneNumberModel;
    SourcePhoneID: string;
    SourcePhoneNumber: string;
    TargetPhone: PhoneNumberModel;
    TargetPhoneID: string;
    TargetPhoneNumber: string;
    TransferredBy: UserModel;
    TransferredByID: string;
    TransferredByName: string;
    Status: TransferStatus;
    CreditType: CreditType;
    CreditsTransferred: number;
    TransferredAt: string;
}

export enum TransferStatus {
    SUCCESS = "SUCCESS", FAILED = "FAILED"
}


export const mapToTransferLogs = (log: any, phones: PhoneNumberModel[], users: UserModel[]) => {
    let fromPhone = phones.find(x => x.ID === log.fromId);
    let toPhone = phones.find(x => x.ID === log.toId);
    let user = users.find(x => x.ID === log.createdById);
    const isAutoCreditTransfer = log.createdById === AutomationRulesLabel.SENDERID;
    return {
        SourcePhone: fromPhone,
        SourcePhoneID: fromPhone?.ID,
        SourcePhoneNumber: UtilityService.maskPhoneNumberOnLength(fromPhone?.PhoneNumber),
        TargetPhone: toPhone,
        TargetPhoneID: toPhone?.ID,
        TargetPhoneNumber: UtilityService.maskPhoneNumberOnLength(toPhone?.PhoneNumber),
        CreditType: (creditTypeTexts as any)[(CreditType as any)[log.type]],
        Status: log.status.toUpperCase() as TransferStatus,
        TransferredBy: user,
        TransferredByID: user?.ID,
        TransferredByName: isAutoCreditTransfer ? "Auto Credit Transfer" : ((user?.FirstName || "") + " " + (user?.LastName || "")).trim(),
        CreditsTransferred: log.credits,
        TransferredAt: UtilityService.convertDateToDay(new Date(log.createdDateTime))
    } as ITransferLogModel;
}